import { StickyOptions } from '../../models/kt';

export const defaultStickyOptions: StickyOptions = {
   offset: 200,
   reverse: false,
   animation: true,
   animationSpeed: '0.3s',
   animationClass: 'animation-slide-in-down',
}
